<template>
  <v-container>
    <loading-effect />
    <dd-sub-header>
        入力コンポーネント
    </dd-sub-header>
    <v-row>

      <v-col :cols=4>

        <v-card
          class="mx-auto"
          max-width="688"
        >

          <v-card-title>
            DdTextBox
          </v-card-title>

          <v-card-subtitle>
            標準テキストボックス
          </v-card-subtitle>

          <v-card-text>
            <dd-text-box
              label="数字"
              v-model="value"
              :length="25"
              :required="true"
              :valueType="ctypes.InputTypes.Number"/>
          </v-card-text>
          <v-card-text>
            {{ value }}
          </v-card-text>
        </v-card>

      </v-col>

      <v-col :cols=4>

        <v-card
          class="mx-auto"
          max-width="688"
        >

          <v-card-title>
            DdTextBox
          </v-card-title>

          <v-card-subtitle>
            標準テキストボックス(readonly)
          </v-card-subtitle>

          <v-card-text>
            <dd-text-box
              label="数字"
              v-model="value"
              :readonly="true"
              :length="25"
              :required="false"
              :valueType="ctypes.InputTypes.Free"/>
          </v-card-text>
          <v-card-text>
            {{ value }}
          </v-card-text>
        </v-card>

      </v-col>

      <v-col :cols=4>

        <v-card
          class="mx-auto"
          max-width="688"
        >

          <v-card-title>
            DdTextBox
          </v-card-title>

          <v-card-subtitle>
            標準テキストボックス(郵便番号)
          </v-card-subtitle>

          <v-card-text>
            <dd-text-box
              label="郵便番号"
              v-model="postCode"
              :length="8"
              :required="false"
              :appendValidators="[Validators.postCodeValidate]"
              :appendFormatter="Complement.parsePostCode"
              :appendUnFormatter="Complement.unformatPostCode"
              :valueType="ctypes.InputTypes.AlphanumericWithSymbol"/>
          </v-card-text>
          <v-card-text>
            {{ postCode }}
          </v-card-text>
        </v-card>

      </v-col>

      <v-col :cols=4>

        <v-card
          class="mx-auto"
          max-width="688"
        >

          <v-card-title>
            DdCodeTextBox
          </v-card-title>

          <v-card-subtitle>
            標準コードテキストボックス
          </v-card-subtitle>

          <v-card-text>
            <dd-code-text-box
              label="取引先コード"
              v-model="codeValue"
              :length="10"
              :item-list="hacchakuchiList"
              item-value="hacchakutiCd"
              item-text="hachakutiNm"
              :valueType="ctypes.InputTypes.Numerical"
              titleText="発着地マスタ検索"
              :headerList="headers"
              :itemList="filteredHacchakuchiList"/>
          </v-card-text>
          <v-card-text>
            {{ codeValue }}
          </v-card-text>
        </v-card>

      </v-col>

      <v-col :cols=4>

        <v-card
          class="mx-auto"
          max-width="688"
        >

          <v-card-title>
            DdDateBox
          </v-card-title>

          <v-card-subtitle>
            標準日付テキストボックス
          </v-card-subtitle>

          <v-card-text>
            <dd-date-box
              label="適用開始日"
              v-model="dateValue"
              max="2099/12/31"
              min="2000/01/01"/>
          </v-card-text>
          <v-card-text>
            {{ dateValue }}
          </v-card-text>
        </v-card>

      </v-col>

      <v-col :cols=4>

        <v-card
          class="mx-auto"
          max-width="688"
        >

          <v-card-title>
            DdYearMonthBox
          </v-card-title>

          <v-card-subtitle>
            標準年月ボックス
          </v-card-subtitle>

          <v-card-text>
            <dd-year-month-box
              label="決算年月"
              v-model="yearMonthValue"
              max="2099/12"
              min="2000/01"/>
          </v-card-text>
          <v-card-text>
            {{ yearMonthValue }}
          </v-card-text>
        </v-card>

      </v-col>

      <v-col :cols=4>

        <v-card
          class="mx-auto"
          max-width="688"
        >

          <v-card-title>
            DdTimeBox<br>
            下段が日跨ぎ設定
          </v-card-title>

          <v-card-subtitle>
            標準時刻ボックス
          </v-card-subtitle>

          <v-card-text>
            <dd-time-box
              label="出社予定時刻"
              v-model="timeValue"/>
            <dd-time-box
              label="帰社予定時刻"
              v-model="timeValue"
              :is-straddle="true"/>
          </v-card-text>
          <v-card-text>
            {{ timeValue }}
          </v-card-text>
        </v-card>

      </v-col>

      <v-col :cols=4>

        <v-card
          class="mx-auto"
          max-width="688"
        >

          <v-card-title>
            DdNarrowDownTextBox
          </v-card-title>

          <v-card-subtitle>
            絞り込みテキストボックス
          </v-card-subtitle>

          <v-card-text>
            <dd-narrow-down-text-box
              label="絞り込み条件"
              v-model="narrowDownValue"
              :length="10"
              />
          </v-card-text>
          <v-card-text>
            {{ narrowDownValue }}
          </v-card-text>
        </v-card>

      </v-col>

      <v-col :cols=4>

        <v-card
          class="mx-auto"
          max-width="688"
        >

          <v-card-title>
            DdFileInput
          </v-card-title>

          <v-card-subtitle>
            ファイル
          </v-card-subtitle>

          <v-card-text>
            <dd-file-input
              label="ファイルアップロード"
              v-model="fileValue"
              />
          </v-card-text>
          <v-card-text>
            {{ fileValue }}
          </v-card-text>
        </v-card>

      </v-col>

      <v-col :cols=4>

        <v-card
          class="mx-auto"
          max-width="688"
        >

          <v-card-title>
            DdNumericBox
          </v-card-title>

          <v-card-subtitle>
            数値
          </v-card-subtitle>

          <v-card-text>
            <dd-numeric-box
              label="数値"
              v-model="numericValue"
              :required="true"
              :integerDigit="5"
              :minorDigit="2"
              />
          </v-card-text>
          <v-card-text>
            {{ numericValue }}
          </v-card-text>
        </v-card>

      </v-col>

      <v-col :cols=4>

        <v-card
          class="mx-auto"
          max-width="688"
        >

          <v-card-title>
            DdDropDown
          </v-card-title>

          <v-card-subtitle>
            単一ドロップダウン
          </v-card-subtitle>

          <v-card-text>
            <dd-drop-down
              v-model="dropdown1value"
              :items="dropDownItems"
              :required="true"
              />
          </v-card-text>
          <v-card-text>
            {{ dropdown1value }}
          </v-card-text>
        </v-card>

      </v-col>

      <v-col :cols=4>

        <v-card
          class="mx-auto"
          max-width="688"
        >

          <v-card-title>
            DdDropDownMulti
          </v-card-title>

          <v-card-subtitle>
            複数ドロップダウン
          </v-card-subtitle>

          <v-card-text>
            <dd-drop-down-multi
              v-model="dropdown2value"
              :items="dropDownItems"
              :required="true"
              />
          </v-card-text>
          <v-card-text>
            {{ dropdown2value }}
          </v-card-text>
        </v-card>

      </v-col>

      <v-col :cols=4>

        <v-card
          class="mx-auto"
          max-width="688"
        >

          <v-card-title>
            DdTextArea
          </v-card-title>

          <v-card-subtitle>
            テキストエリア
          </v-card-subtitle>

          <v-card-text>
            <dd-text-area
              v-model="textareaValue"
              :required="true"
              />
          </v-card-text>
          <v-card-text>
            {{ textareaValue }}
          </v-card-text>
        </v-card>

      </v-col>

      <v-col :cols=4>

        <v-card
          class="mx-auto"
          max-width="688"
        >

          <v-card-title>
            DdCheckbox
          </v-card-title>

          <v-card-subtitle>
            チェックボックス
          </v-card-subtitle>

          <v-card-text>
            <dd-checkbox
              v-model="checkValue"
              />
          </v-card-text>
          <v-card-text>
            {{ checkValue }}
          </v-card-text>
        </v-card>

      </v-col>

      <v-col :cols=4>

        <v-card
          class="mx-auto"
          max-width="688"
        >

          <v-card-title>
            DdSwitch
          </v-card-title>

          <v-card-subtitle>
            スイッチ
          </v-card-subtitle>

          <v-card-text>
            <dd-switch
              v-model="checkValue"
              />
          </v-card-text>
          <v-card-text>
            {{ checkValue }}
          </v-card-text>
        </v-card>

      </v-col>

      <v-col :cols=4>

        <v-card
          class="mx-auto"
          max-width="688"
        >

          <v-card-title>
            DdRadioButton
          </v-card-title>

          <v-card-subtitle>
            スイッチ
          </v-card-subtitle>

          <v-card-text>
            <v-radio-group v-model="radioGroup">
              <dd-radio-button
                label="C#"
                value="C#"
              />
              <dd-radio-button
                label="javascript"
                value="javascript"
              />
              <dd-radio-button
                label="SQL"
                value="SQL"
              />
            </v-radio-group>
          </v-card-text>
          <v-card-text>
            {{ radioGroup }}
          </v-card-text>
        </v-card>

      </v-col>

    </v-row>

    <dd-sub-header>
        ボタンコンポーネント
    </dd-sub-header>

    <v-row>
      <v-col :cols=4>

        <v-card
          class="mx-auto"
          max-width="688"
        >

          <v-card-title>
            DbDefaultButton
          </v-card-title>

          <v-card-subtitle>
            標準ボタン<br/>
            押下時にローディングエフェクト
          </v-card-subtitle>

          <v-card-text>
            <dd-default-button
              :onClick="DbDefaultButtonOnClick">
              検索
            </dd-default-button>
          </v-card-text>

        </v-card>

      </v-col>
      <v-col :cols=4>

        <v-card
          class="mx-auto"
          max-width="688"
        >

          <v-card-title>
            DdFooterButton
          </v-card-title>

          <v-card-subtitle>
            フッターボタン<br/>
            押下時にalert
          </v-card-subtitle>

          <v-card-text>
            <dd-footer-button
              :onClick="DdFooterButtonOnClick">
              CSV出力
            </dd-footer-button>
          </v-card-text>

        </v-card>

      </v-col>

      <v-col :cols=4>

        <v-card
          class="mx-auto"
          max-width="688"
        >

          <v-card-title>
            DdIconButton
          </v-card-title>

          <v-card-subtitle>
            アイコンボタン
          </v-card-subtitle>

          <v-card-text>
            <dd-icon-button
              @click="onShowDialogButtonClick"
              icon="mdi-magnify"
              color="blue"/>
            <dd-icon-button
              :onClick="DdFooterButtonOnClick"
              icon="mdi-calendar"
              color="blue"/>
            <dd-icon-button
              :onClick="DdFooterButtonOnClick"
              icon="mdi-clock"
              color="blue"/>
            <dd-icon-button
              :onClick="DdFooterButtonOnClick"
              icon="mdi-plus-box"
              color="blue"/>
            <dd-icon-button
              :onClick="DdFooterButtonOnClick"
              icon="mdi-sync-off"
              color="blue"/>
            <dd-icon-button
              :onClick="DdFooterButtonOnClick"
              icon="mdi-arrow-up"
              color="blue"/>
            <dd-icon-button
              :onClick="DdFooterButtonOnClick"
              icon="mdi-arrow-down"
              color="blue"/>
            <dd-icon-button
              :onClick="DdFooterButtonOnClick"
              icon="mdi-content-copy"
              color="blue"/>
            <dd-icon-button
              @click="onConfirmDialogOpen"
              icon="mdi-delete"
              color="blue"/>
          </v-card-text>

        </v-card>

      </v-col>

    </v-row>

    <dd-sub-header>
      表示系コンポーネント
    </dd-sub-header>

    <v-row>
      <v-col :cols=4>

        <v-card
          class="mx-auto"
          max-width="688"
        >

          <v-card-title>
            DdSubHeader
          </v-card-title>

          <v-card-subtitle>
            サブヘッダー
          </v-card-subtitle>

          <v-card-text>
            <dd-sub-header>
              サブヘッダー
            </dd-sub-header>
          </v-card-text>

        </v-card>

      </v-col>
      <v-col :cols=4>

        <v-card
          class="mx-auto"
          max-width="688"
        >

          <v-card-title>
            DdDialog
          </v-card-title>

          <v-card-subtitle>
            マスタ検索ダイアログ
          </v-card-subtitle>

          <v-card-text>
            <dd-dialog
              :showDialog="showDialog"
              titleText="発着地マスタ検索"
              :headerList="headers"
              :itemList="filteredHacchakuchiList"
              @close="onDialogClose"/>
          </v-card-text>
          <v-card-text>
            {{ dialogSelectedValue }}
          </v-card-text>
        </v-card>

      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdTextBox from '@/components/DdTextBox'
import DdDateBox from '@/components/DdDateBox'
import DdYearMonthBox from '@/components/DdYearMonthBox'
import DdTimeBox from '@/components/DdTimeBox'
// import DdDateBox2 from '@/components/DdDateBox2'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdFileInput from '@/components/DdFileInput'
import DdNumericBox from '@/components/DdNumericBox'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdFooterButton from '@/components/DdFooterButton'
import DdIconButton from '@/components/DdIconButton'
import DdSubHeader from '@/components/DdSubHeader'
import DdDropDown from '@/components/DdDropDown'
import DdDropDownMulti from '@/components/DdDropDownMulti'
import DdTextArea from '@/components/DdTextArea'
import DdDialog from '@/components/DdMasterSearchDialog'
import DdCheckbox from '@/components/DdCheckbox'
import DdSwitch from '@/components/DdSwitch'
import DdRadioButton from '@/components/DdRadioButton'

import LoadingEffect from '@/components/LoadingEffect'
import controls from '@/rahmen/controls'
import Logger from '@/rahmen/logger'
import effects from '@/rahmen/utils/effects'

import viewMixin from '@/mixins/viewMixins'
import { mapGetters } from 'vuex'
import filter from '@/rahmen/utils/filters'

export default {
  name: 'HelloWorld',
  mixins: [viewMixin],
  components: {
    DdTextBox,
    DdDateBox,
    DdYearMonthBox,
    DdTimeBox,
    DdCheckbox,
    DdSwitch,
    DdRadioButton,
    // DdDateBox2,
    DdNarrowDownTextBox,
    DdFileInput,
    DdNumericBox,
    DdDefaultButton,
    DdFooterButton,
    DdSubHeader,
    LoadingEffect,
    DdIconButton,
    DdDropDown,
    DdDropDownMulti,
    DdTextArea,
    DdCodeTextBox,
    DdDialog
  },
  data: () => ({
    ctypes: controls,
    value: '',
    showDialog: false,
    dateValue: '2020/10/30',
    date2Value: '2020-12-31',
    codeValue: '14131',
    narrowDownValue: '絞り込み',
    postCode: '',
    fileValue: null,
    numericValue: 10000.89,
    dialogSelectedValue: null,
    yearMonthValue: '2020/11',
    checkValue: true,
    radioGroup: 'C#',
    timeValue: '23:59',
    dropdown1value: '2',
    dropdown2value: [],
    textareaValue: 'aaaaa\nbbbbb\nccccc',
    dropDownItems: [
      { value: null, text: '' },
      { value: '0', text: 'Windows 3.1' },
      { value: '1', text: 'Windows 95' },
      { value: '2', text: 'Windows 98' },
      { value: '3', text: 'Windows 98 SE' },
      { value: '4', text: 'Windows 2000' },
      { value: '5', text: 'Windows Me' },
      { value: '6', text: 'Windows XP' },
      { value: '7', text: 'Windows Vista' },
      { value: '8', text: 'Windows 8' },
      { value: '9', text: 'Windows 10' }
    ],
    headers: [
      { width: '60px', text: '会社コード', value: 'kaishaCd' },
      { width: '90px', text: '発着地コード', value: 'hacchakutiCd' },
      { width: '90px', text: '適用開始日', value: 'tekiyoStartYmdDisp' },
      { width: '90px', text: '適用終了日', value: 'tekiyoEndYmdDisp' },
      { width: '200px', text: '発着地名', value: 'hachakutiNm' },
      { width: '200px', text: '発着地請求名', value: 'hachakutiNmSei' },
      { width: '200px', text: '発着地（カナ）', value: 'HachakutiNmKn' },
      { width: '200px', text: '取引先コード', value: 'torihikisakiCd' },
      { width: '200px', text: '郵便番号', value: 'yubinNo' },
      { width: '200px', text: '住所', value: 'jusho' },
      { width: '90px', text: '電話番号', value: 'telNo' },
      { width: '200px', text: '取引先担当者', value: 'tantoshaNm' },
      { width: '90px', text: '発着地グループコード', value: 'hacchakutiGroupCd' }
    ]
  }),
  created () {
    this.$store.dispatch('DDMasters/loadMasters', { list: ['msthacchakuchi'], version: 1 })
  },
  mounted () {
    this.value = '担当者名'
    this.logger = new Logger('token', 'name')
    this.logger.debug('HelloWord.mounted', { id: 0, name: 'test' })
  },
  computed: {
    ...mapGetters({
      hacchakuchiList: 'DDMasters/mstHacchakuchi'
    }),
    filteredHacchakuchiList () {
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    }
  },
  methods: {
    DdCodeTextBoxOnClick: function () {
      console.log('test')
    },
    DbDefaultButtonOnClick: function () {
      effects.loadStart()
      window.setTimeout(effects.loadComplete, 3000)
    },
    DdFooterButtonOnClick: function () {
      alert('OnClick')
    },
    onInput: function () {
      console.log(this.value)
    },
    onShowDialogButtonClick: function (e) {
      console.log('onShowDialogButtonClick', e)
      this.showDialog = true
    },
    onDialogClose: function (e) {
      this.dialogSelectedValue = e
      this.showDialog = false
    },
    onConfirmDialogOpen: function (e) {
      confirm('削除してもよろしいですか？')
    }
  }
}
</script>
